<div [class.rtl]="currLang == 'ar'" class="container">

    <div *ngIf="isLoading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>

    <div class="row">
        <div class="col-12 header-title" [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
            <img src="./../../../assets/images/back.svg" class="back" (click)="back()"
                [ngStyle]="{'transform': currLang == 'en' ? 'none' : 'rotate(180deg)'}">
            {{'messages.create-msg.header' | translate}}
        </div>
    </div>
    <div class='form-wrapper'>

        <form #myForm='ngForm' [formGroup]='messageForm'>

            <!-- title and message via -->
            <div class="row">
                <div class="col-6">
                    <mat-form-field appearance="outline" dir="ltr">
                        <mat-label>{{'messages.create-msg.msg-title' | translate}}</mat-label>
                        <input matInput type="text" formControlName='title'>
                        <mat-error>
                            {{createMessageValidation('title')}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-6 selector">
                    <mat-form-field appearance="outline" dir="ltr">
                        <mat-label>{{'messages.create-msg.msg-via' | translate}}*</mat-label>
                        <mat-select formControlName='type'>
                            <mat-option *ngFor='let item of types' [disabled]='item.status=="disabled"'
                                [value]="item.value">{{item.name}}</mat-option>
                        </mat-select>
                        <mat-error>
                            {{createMessageValidation('type')}}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <!-- Recepient -->
            <div class="row">
                <div class="col-10">
                    <mat-form-field appearance="outline" dir="ltr">
                        <mat-label>{{'messages.create-msg.recipients2' | translate}}</mat-label>
                        <mat-select #recepientSelect formControlName='roles' multiple>

                            <mat-option (click)="selectAllUsers()"
                                [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right','direction': currLang == 'en' ? 'ltr' : 'rtl'}"
                                [value]="recipients[0].value">{{'messages.create-msg.all-user' |
                                translate}}
                            </mat-option>
                            <mat-option (click)="onChangeRecepientsSelect($event)"
                                [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right','direction': currLang == 'en' ? 'ltr' : 'rtl'}"
                                *ngFor='let item of recipients.slice(1)' [value]="item.value">{{item.name}}</mat-option>

                            <mat-option style='visibility: hidden;' #usersManually [value]="'usersManually'">
                                {{singleReciepintName ? singleReciepintName :'messages.create-msg.multi-recip' | translate}}
                            </mat-option>


                            <div class='col-12' [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                                <p (click)='openUsersPopup()' style='color:#1D71D3;cursor: pointer'>
                                    {{ 'messages.create-msg.select-manually' | translate}}
                                </p>
                            </div>



                        </mat-select>
                        <mat-error>
                            {{createMessageValidation('recipients')}}
                        </mat-error>

                    </mat-form-field>
                </div>
                <div class="col-2"><span class="clear"
                        (click)="clearAllSelction()">{{'messages.create-msg.clear-selected' | translate}}</span></div>

            </div>

            <!-- content -->
            <div class="row text-container">
                <div class="col-12">
                    <!-- editor -->
                    <quill-editor formControlName='content' [styles]="editorStyle" customToolbarPosition='bottom'
                        trackChanges="all" [modules]="modules">

                        <div quill-editor-toolbar class='d-flex toolbar-container'>


                            <!-- attach file -->
                            <span class="ql-formats">
                                <div class='editor-icon' (click)="file.click()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19.886" height="18.25"
                                        viewBox="0 0 19.886 18.25">
                                        <g id="attach" transform="translate(0.125 -21.208)">
                                            <path id="Path_5589" data-name="Path 5589"
                                                d="M5.037,39.333a5.037,5.037,0,0,1-3.562-8.6l9.281-9.281a.409.409,0,0,1,.578.578L2.054,31.312a4.219,4.219,0,0,0,5.967,5.967l9.9-9.9a3.062,3.062,0,0,0-4.331-4.331L4.649,31.989a1.905,1.905,0,1,0,2.694,2.694l8.322-8.322a.409.409,0,1,1,.578.578L7.922,35.262a2.723,2.723,0,1,1-3.851-3.851l8.942-8.942A3.88,3.88,0,1,1,18.5,27.957l-9.9,9.9A5,5,0,0,1,5.037,39.333Z"
                                                transform="translate(0 0)" fill="#707070" stroke="#707070"
                                                stroke-width="0.25" />
                                            <path id="Path_5590" data-name="Path 5590"
                                                d="M5.037,39.333a5.037,5.037,0,0,1-3.562-8.6l9.281-9.281a.409.409,0,0,1,.578.578L2.054,31.312a4.219,4.219,0,0,0,5.967,5.967l9.9-9.9a3.062,3.062,0,0,0-4.331-4.331L4.649,31.989a1.905,1.905,0,1,0,2.694,2.694l8.322-8.322a.409.409,0,1,1,.578.578L7.922,35.262a2.723,2.723,0,1,1-3.851-3.851l8.942-8.942A3.88,3.88,0,1,1,18.5,27.957l-9.9,9.9A5,5,0,0,1,5.037,39.333Z"
                                                transform="translate(0 0)" fill="#707070" stroke="#707070"
                                                stroke-width="0.25" />
                                        </g>
                                    </svg>

                                </div>
                            </span>

                            <!-- text format -->
                            <span class="ql-formats">

                                <div class="btn-group dropup">
                                    <!-- <button type="button" class="dropdown-toggle"  style='visibility: hidden;' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button> -->

                                    <div class='editor-icon' data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20.571" height="18"
                                            viewBox="0 0 20.571 18">
                                            <g id="text" transform="translate(0 -28.647)">
                                                <path id="Path_5591" data-name="Path 5591"
                                                    d="M7.714,29.933h5.143V32.5h1.286V28.647H0V32.5H1.286V29.933H6.429V45.361H3.857v1.286h6.429V45.361H7.714Z"
                                                    fill="#707070" />
                                                <path id="Path_5592" data-name="Path 5592"
                                                    d="M200.529,143.235v2.571h1.286v-1.286h3.857v10.286H203.1v1.286h6.429v-1.286h-2.571V144.521h3.857v1.286H212.1v-2.571Z"
                                                    transform="translate(-191.529 -109.445)" fill="#707070" />
                                            </g>
                                        </svg>
                                    </div>


                                    <div class="dropdown-menu" (click)='$event.stopPropagation()'>


                                        <span class="ql-formats">
                                            <select class="ql-font">
                                                <option value="serif">Serif</option>
                                                <option value="monospace" selected>Monospace</option>
                                                <option value="roboto">Roboto</option>
                                            </select>
                                        </span>

                                        <span class="ql-formats">
                                            <button class="ql-bold"></button>
                                        </span>

                                        <span class="ql-formats">
                                            <button class="ql-italic"></button>
                                        </span>

                                        <span class="ql-formats">
                                            <button class="ql-underline"></button>
                                        </span>

                                        <span class="ql-formats">
                                            <select class="ql-size" [title]="'Char size'">
                                            </select>
                                            <select class="ql-color" [title]="'Char color'">
                                            </select>
                                            <select class="ql-background" [title]="'Bg color'">
                                            </select>
                                        </span>
                                        <!-- <span class="ql-formats">
                                                <div id="divider"></div>
                                            </span> -->
                                        <span class="ql-formats">

                                            <select class="ql-align" [title]="'Aligment'">
                                                <option selected></option>
                                                <option value="center"></option>
                                                <option value="right"></option>
                                                <option value="justify"></option>
                                            </select>

                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-list" value="ordered"></button>
                                        </span>

                                        <span class="ql-formats">
                                            <button class="ql-list" value="bullet"></button>
                                        </span>

                                        <span class="ql-formats">
                                            <button type="button" class="ql-indent" value="+1"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button type="button" class="ql-indent" value="-1"></button>
                                        </span>


                                    </div>

                                </div>

                            </span>

                            <!-- attach link  -->
                            <span class="ql-formats">
                                <div class='editor-icon' (click)='link.click()'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17.126" height="17.15"
                                        viewBox="0 0 17.126 17.15">
                                        <g id="_222222" data-name="222222" transform="translate(-0.999 -0.675)">
                                            <path id="Path_5600" data-name="Path 5600"
                                                d="M2.1,16.7a3.684,3.684,0,0,0,5.3,0l2.8-2.8a5.257,5.257,0,0,1-1.7-.4L6.3,15.7a2.36,2.36,0,0,1-1.6.7h0a2.36,2.36,0,0,1-1.6-.7,2.234,2.234,0,0,1,0-3.2L7,8.6a2.354,2.354,0,0,1,3.3,0,.668.668,0,0,0,1,0,.744.744,0,0,0,.1-.9l-.1-.1a2.651,2.651,0,0,0-.6-.5,3.627,3.627,0,0,0-4.6.5L2.3,11.4A3.533,3.533,0,0,0,2.1,16.7Z"
                                                fill="#707070" />
                                            <g id="Group_5441" data-name="Group 5441">
                                                <path id="Path_5601" data-name="Path 5601"
                                                    d="M17,7.1a3.684,3.684,0,0,0,0-5.3,3.684,3.684,0,0,0-5.3,0L8.9,4.6a4.193,4.193,0,0,1,1.6.4l2.2-2.2a2.351,2.351,0,0,1,4,1.6A1.99,1.99,0,0,1,16,6L12.1,9.9a2.354,2.354,0,0,1-3.3,0c0-.1-.2-.2-.4-.2a.764.764,0,0,0-.5.2.668.668,0,0,0,0,1,2.589,2.589,0,0,0,1.1.7l.3.1a.349.349,0,0,1,.2.1h.2a.367.367,0,0,1,.3.1h1l.6-.1a2.748,2.748,0,0,0,1.6-1Z"
                                                    fill="#707070" />
                                                <path id="Path_5602" data-name="Path 5602" d="M8.4,4.6Z"
                                                    fill="#707070" />
                                            </g>
                                        </g>
                                    </svg>

                                </div>
                            </span>


                            <!--  emoji -->
                            <span class="ql-formats">
                                <div (click)='emoji.click()' class="editor-icon">
                                    <svg id="happy" xmlns="http://www.w3.org/2000/svg" width="20.117" height="20.117"
                                        viewBox="0 0 20.117 20.117">
                                        <g id="Group_4901" data-name="Group 4901">
                                            <g id="Group_4900" data-name="Group 4900">
                                                <path id="Path_5351" data-name="Path 5351"
                                                    d="M17.171,2.946A10.059,10.059,0,1,0,2.946,17.171,10.059,10.059,0,1,0,17.171,2.946ZM10.059,18.92a8.861,8.861,0,1,1,8.861-8.861A8.871,8.871,0,0,1,10.059,18.92Z"
                                                    transform="translate(0 0)" fill="#707070" />
                                            </g>
                                        </g>
                                        <g id="Group_4903" data-name="Group 4903" transform="translate(4.126 6.651)">
                                            <g id="Group_4902" data-name="Group 4902">
                                                <path id="Path_5352" data-name="Path 5352"
                                                    d="M109.475,170.434a2.581,2.581,0,0,0-3.645,0,.614.614,0,0,0,.868.868,1.352,1.352,0,0,1,1.91,0,.614.614,0,0,0,.868-.868Z"
                                                    transform="translate(-105.65 -169.681)" fill="#707070" />
                                            </g>
                                        </g>
                                        <g id="Group_4905" data-name="Group 4905" transform="translate(11.986 6.651)">
                                            <g id="Group_4904" data-name="Group 4904">
                                                <path id="Path_5353" data-name="Path 5353"
                                                    d="M310.737,170.434a2.581,2.581,0,0,0-3.645,0,.614.614,0,1,0,.868.868,1.352,1.352,0,0,1,1.91,0,.614.614,0,0,0,.868-.868Z"
                                                    transform="translate(-306.912 -169.681)" fill="#707070" />
                                            </g>
                                        </g>
                                        <g id="Group_4907" data-name="Group 4907" transform="translate(4.003 10.372)">
                                            <g id="Group_4906" data-name="Group 4906">
                                                <path id="Path_5354" data-name="Path 5354"
                                                    d="M117.148,267.175H106.265a.614.614,0,0,0-.614.614,6.055,6.055,0,1,0,12.111,0A.614.614,0,0,0,117.148,267.175Zm-5.442,5.442a4.835,4.835,0,0,1-4.789-4.214H116.5A4.835,4.835,0,0,1,111.706,272.617Z"
                                                    transform="translate(-105.651 -267.175)" fill="#707070" />
                                            </g>
                                        </g>
                                    </svg>
                                </div>

                            </span>


                            <!-- ngx-quill btns (hidden) -->
                            <button #emoji class="ql-emoji" style='visibility: hidden;' [title]="'Bold'"></button>
                            <button #link class="ql-link" style='visibility: hidden;' [title]="'Bold'"></button>
                            <input (change)="onFileChanged($event)" multiple type='file' accept="image/*" #file
                                style='visibility: hidden;' />
                        </div>



                    </quill-editor>

                </div>
            </div>
            <div class="images-container row" *ngIf="selectedFile.length">
                <h6 class="col-12">{{'messages.create-msg.attach' | translate}}</h6>
                <div class="col-4" *ngFor="let file of selectedFile, index as in">
                    {{file.name}}
                    <span class="float-right remove-icon" (click)="removeFile(in)">x</span>
                </div>
            </div>

            <!-- Buttons -->
            <div class='row'>
                <div class="col-12 btns-wrapper">
                    <button type='button' (click)='discarMessage()' class="btn"><span class='p-btn' style='color:#707070; 
                            font-size: 14px;'>{{'messages.create-msg.discard-msg' | translate}}</span></button>
                    <button type='button' (click)='submitMessage()' [disabled]='messageForm.invalid'
                        class="btn btn-primary" style="
                        font-size: 14px; background-color: #1D71D3;"><span
                            class='p-btn'>{{'messages.create-msg.send-msg' | translate}}</span></button>
                </div>

            </div>

        </form>


    </div>


    <div id="snackbar-success">{{'messages.create-msg.send-success' | translate}}</div>
    <div id="snackbar-error">{{'messages.create-msg.send-error' | translate}}</div>
</div>